<template>
  <v-form ref="simpleSearchPes">
    <v-row class="mx-5">
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          label="Acervo"
          dense
          :items="collections"
          :value="filter.idTipoPublicacao"
          @input="onPatchFilter({idTipoPublicacao: $event})"
          hide-details
          item-text="tipoPublicacao"
          item-value="idTipopublicacao"
          outlined
          clearable
          rounded
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        lg="5"
        xl="7"
      >
        <v-text-field
          :value="search"
          dense
          append-icon="fas fa-search accent--text"
          label="Encontre um registro no acervo"
          single-line
          outlined
          rounded
          @input="onPatchFilter({where: {
            nome: $event
          }})"
          @keyup.enter.native="onSearch({form: $refs.simpleSearchPes, $vuetify})"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="text-center"
      >
        <v-btn
          color="accent"
          rounded
          @click="onSearch({form: $refs.simpleSearchPes, $vuetify})"
        >
          BUSCAR
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="text-center"
      >
        <v-btn
          color="accent"
          text
          @click="onSearchTypeChange('advanced')"
        >
          BUSCA AVANÇADA
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import formRules from '@/mixins/form-rules';

export default {
  mixins: [formRules],
  props: {
    collections: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => {},
    },
    search: {
      type: String,
      default: '',
    },
    onPatchFilter: {
      type: Function,
      default: () => {},
    },
    onSearch: {
      type: Function,
      default: () => {},
    },
    onSearchTypeChange: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
